<div class="summary-container">
  <div class="summary-grid">
    <!-- Customer Email Card (Clickable) -->
    <div
      class="summary-card clickable"
      (click)="onCustomerClick()"
      role="button"
      tabindex="0"
      (keydown.enter)="onCustomerClick()"
      (keydown.space)="onCustomerClick()"
    >
      <div class="card-icon">
        <i class="pi pi-user"></i>
      </div>
      <div class="card-content">
        <span class="card-label">Customer Email</span>
        <span class="card-value">{{ getCustomerEmail() }}</span>
      </div>
      <div class="card-action">
        <i class="pi pi-chevron-right"></i>
      </div>
    </div>

    <!-- Products Card (Clickable) - NEW -->
    <div
      class="summary-card clickable"
      (click)="onProductsClick()"
      role="button"
      tabindex="0"
      (keydown.enter)="onProductsClick()"
      (keydown.space)="onProductsClick()"
    >
      <div class="card-icon">
        <i class="pi pi-box"></i>
        <span class="product-badge">{{ getProductCount() }}</span>
      </div>
      <div class="card-content">
        <span class="card-label">Products</span>
        <span class="card-value">{{ getProductsSummary() }}</span>
      </div>
      <div class="card-action">
        <i class="pi pi-chevron-right"></i>
      </div>
    </div>

    <!-- Next Occurrence Date Card (Clickable) -->
    <div
      class="summary-card clickable"
      (click)="onScheduleClick()"
      role="button"
      tabindex="0"
      (keydown.enter)="onScheduleClick()"
      (keydown.space)="onScheduleClick()"
    >
      <div class="card-icon">
        <i class="pi pi-calendar"></i>
      </div>
      <div class="card-content">
        <span class="card-label">Next Occurrence</span>
        <span class="card-value">{{ getNextOccurrenceDate() }}</span>
      </div>
      <div class="card-action">
        <i class="pi pi-chevron-right"></i>
      </div>
    </div>

    <!-- Created Date Card -->
    <div class="summary-card">
      <div class="card-icon">
        <i class="pi pi-calendar-plus"></i>
      </div>
      <div class="card-content">
        <span class="card-label">Created Date</span>
        <span class="card-value">{{ getCreatedDate() }}</span>
      </div>
    </div>

    <!-- Total Cycles Card -->
    <div class="summary-card">
      <div class="card-icon">
        <i class="pi pi-sync"></i>
      </div>
      <div class="card-content">
        <span class="card-label">Total Cycles</span>
        <span class="card-value">{{ getTotalCycles() }}</span>
      </div>
    </div>

    <!-- Lifetime Value Card -->
    <div class="summary-card">
      <div class="card-icon">
        <i class="pi pi-dollar"></i>
      </div>
      <div class="card-content">
        <span class="card-label">Lifetime Value</span>
        <span class="card-value">{{ getLifetimeValue() }}</span>
      </div>
    </div>

    <!-- Last Processing Cycle & Status Card -->
    <div class="summary-card">
      <div class="card-icon">
        <i class="pi pi-info-circle"></i>
      </div>
      <div class="card-content">
        <span class="card-label">LPC & Status</span>
        <div class="status-row">
          <span class="card-value">{{ getLastProcessingCycle() }}</span>
          <p-tag
            [value]="getStatus()"
            [severity]="getStatusSeverity()"
            [rounded]="true"
          />
        </div>
      </div>
    </div>

    <!-- Validation Status Card (Clickable) -->
    <div
      class="summary-card clickable"
      (click)="onValidationClick()"
      role="button"
      tabindex="0"
      (keydown.enter)="onValidationClick()"
      (keydown.space)="onValidationClick()"
    >
      <div class="card-icon">
        <i class="pi pi-shield"></i>
        @if (getValidationErrorCount() > 0) {
          <span class="product-badge error-badge">{{
            getValidationErrorCount()
          }}</span>
        }
      </div>
      <div class="card-content">
        <span class="card-label">Validation</span>
        <p-tag
          [value]="getValidationStatus()"
          [severity]="getValidationSeverity()"
          [rounded]="true"
        />
      </div>
      <div class="card-action">
        <i class="pi pi-chevron-right"></i>
      </div>
    </div>

    <!-- Coupons Card (if any) - Now part of main grid -->
    @if (hasCoupons()) {
      <div
        class="summary-card clickable coupons-card"
        (click)="onCouponsClick()"
        role="button"
        tabindex="0"
        (keydown.enter)="onCouponsClick()"
        (keydown.space)="onCouponsClick()"
      >
        <div class="card-icon">
          <i class="pi pi-ticket"></i>
          <span class="product-badge">{{ getCouponCount() }}</span>
        </div>
        <div class="card-content">
          <span class="card-label">Coupons Applied</span>
          <span class="card-value">{{ getCoupons() }}</span>
        </div>
        <div class="card-action">
          <i class="pi pi-chevron-right"></i>
        </div>
      </div>
    }

    <!-- Notes Card (if any) - Now part of main grid -->
    @if (hasNotes()) {
      <div
        class="summary-card clickable notes-card"
        (click)="onNotesClick()"
        role="button"
        tabindex="0"
        (keydown.enter)="onNotesClick()"
        (keydown.space)="onNotesClick()"
      >
        <div class="card-icon">
          <i class="pi pi-file-edit"></i>
        </div>
        <div class="card-content">
          <span class="card-label">Order Notes</span>
          <span class="card-value">{{ getNotes() }}</span>
        </div>
        <div class="card-action">
          <i class="pi pi-chevron-right"></i>
        </div>
      </div>
    }
  </div>

  <!-- Products Details Table -->
  @if (getProductCount() > 0 || getDisabledProductCount() > 0) {
    <div class="products-section">
      <h3 class="section-title">
        <i class="pi pi-box"></i>
        Order Items Summary ({{ getProductCount() }})
        @if (getDisabledProductCount() > 0) {
          <span class="disabled-count">
            + {{ getDisabledProductCount() }} disabled
          </span>
        }
      </h3>

      <!-- Desktop Table View -->
      <div class="products-table-wrapper desktop-only">
        <table class="products-table">
          <thead>
            <tr>
              <th>Product</th>
              <th class="text-center">Qty</th>
              <th class="text-right">Price</th>
              <th class="text-right">Sale</th>
              <th class="text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            <!-- Enabled Items -->
            @for (item of getEnabledItems(); track item.Id) {
              <tr
                class="clickable-row"
                (click)="onRowClick()"
                role="button"
                tabindex="0"
                (keydown.enter)="onRowClick()"
                (keydown.space)="onRowClick()"
              >
                <td class="product-name">
                  {{ item.Product?.Title || "Product #" + item.ProductId }}
                </td>
                <td class="text-center">{{ item.Quantity }}</td>
                <td class="text-right">
                  {{ formatPrice(item.Price ?? 0) }}
                </td>
                <td class="text-right">
                  {{ item.SalePrice ? formatPrice(item.SalePrice) : "—" }}
                </td>
                <td class="text-right total-col">
                  {{
                    formatPrice(
                      (item.SalePrice ?? item.Price ?? 0) * (item.Quantity ?? 0)
                    )
                  }}
                </td>
              </tr>
            }

            <!-- Disabled Items (greyed out) -->
            @for (item of getDisabledItems(); track item.Id) {
              <tr
                class="clickable-row disabled-row"
                (click)="onRowClick()"
                role="button"
                tabindex="0"
                (keydown.enter)="onRowClick()"
                (keydown.space)="onRowClick()"
              >
                <td class="product-name">
                  <span
                    class="disabled-indicator"
                    [pTooltip]="getDisabledReason(item)"
                    tooltipPosition="right"
                  >
                    <i [class]="'pi ' + getDisabledIcon(item)"></i>
                    {{ item.Product?.Title || "Product #" + item.ProductId }}
                  </span>
                </td>
                <td class="text-center">{{ item.Quantity }}</td>
                <td class="text-right">
                  {{ formatPrice(item.Price ?? 0) }}
                </td>
                <td class="text-right">
                  {{ item.SalePrice ? formatPrice(item.SalePrice) : "—" }}
                </td>
                <td class="text-right total-col">
                  {{
                    formatPrice(
                      (item.SalePrice ?? item.Price ?? 0) * (item.Quantity ?? 0)
                    )
                  }}
                </td>
              </tr>
            }
          </tbody>
          <tfoot>
            <!-- Items Total (before discount) -->
            <tr class="footer-totals-row">
              <td colspan="5" class="footer-row-content">
                <div class="footer-row-inner">
                  <span class="footer-label">Order Items Total:</span>
                  <span class="footer-value">{{
                    getItemsTotalBeforeDiscount()
                  }}</span>
                </div>
              </td>
            </tr>

            <!-- Price Discount (only show if there are sale prices) -->
            @if (hasPriceDiscounts()) {
              <tr class="footer-totals-row">
                <td colspan="5" class="footer-row-content">
                  <div class="footer-row-inner">
                    <span class="footer-label">Price Discount:</span>
                    <span class="footer-value discount-value">{{
                      getPriceDiscount()
                    }}</span>
                  </div>
                </td>
              </tr>
            }

            <!-- Coupon Discounts (from totals) -->
            @for (coupon of getCouponDiscounts(); track coupon.Description) {
              <tr class="footer-totals-row">
                <td colspan="5" class="footer-row-content">
                  <div class="footer-row-inner">
                    <span class="footer-label">
                      <i class="pi pi-ticket mr-1"></i>
                      Coupon Discount ({{ coupon.Description }}):
                    </span>
                    <span class="footer-value discount-value">{{
                      formatPrice(-Math.abs(coupon.Amount))
                    }}</span>
                  </div>
                </td>
              </tr>
            }

            <!-- Final Subtotal -->
            <tr class="footer-totals-row subtotal-row">
              <td colspan="5" class="footer-row-content">
                <div class="footer-row-inner">
                  <span class="footer-label subtotal-label"
                    >Order Items Subtotal:</span
                  >
                  <span class="footer-value subtotal-final-value">{{
                    getTotalPrice()
                  }}</span>
                </div>
              </td>
            </tr>

            <!-- Order Total (including shipping and tax) -->
            @if (hasShippingOrTax()) {
              <tr class="footer-totals-row order-total-row">
                <td colspan="5" class="footer-row-content">
                  <div class="footer-row-inner">
                    <span class="footer-label order-total-label"
                      >Order total:</span
                    >
                    <span class="footer-value order-total-value">{{
                      getOrderTotal()
                    }}</span>
                  </div>
                </td>
              </tr>
            }
          </tfoot>
        </table>
      </div>

      <!-- Mobile Card View -->
      <div class="products-cards-wrapper mobile-only">
        <!-- Enabled Items -->
        @for (item of getEnabledItems(); track item.Id) {
          <div
            class="product-card"
            (click)="onRowClick()"
            role="button"
            tabindex="0"
            (keydown.enter)="onRowClick()"
            (keydown.space)="onRowClick()"
          >
            <div class="product-card-header">
              <span class="product-card-name">
                {{ item.Product?.Title || "Product #" + item.ProductId }}
              </span>
              <span class="product-card-total">
                {{
                  formatPrice(
                    (item.SalePrice ?? item.Price ?? 0) * (item.Quantity ?? 0)
                  )
                }}
              </span>
            </div>
            <div class="product-card-details">
              <span class="detail-item">Qty: {{ item.Quantity }}</span>
              <span class="detail-separator">|</span>
              <span class="detail-item">
                @if (item.SalePrice) {
                  <span class="strikethrough">{{
                    formatPrice(item.Price ?? 0)
                  }}</span>
                  {{ formatPrice(item.SalePrice) }}
                } @else {
                  {{ formatPrice(item.Price ?? 0) }}
                }
              </span>
            </div>
          </div>
        }

        <!-- Disabled Items -->
        @for (item of getDisabledItems(); track item.Id) {
          <div
            class="product-card disabled"
            (click)="onRowClick()"
            role="button"
            tabindex="0"
            (keydown.enter)="onRowClick()"
            (keydown.space)="onRowClick()"
            [pTooltip]="getDisabledReason(item)"
            tooltipPosition="top"
          >
            <div class="product-card-header">
              <i [class]="'pi ' + getDisabledIcon(item)"></i>
              <span class="product-card-name">
                {{ item.Product?.Title || "Product #" + item.ProductId }}
              </span>
              <span class="product-card-total strikethrough">
                {{
                  formatPrice(
                    (item.SalePrice ?? item.Price ?? 0) * (item.Quantity ?? 0)
                  )
                }}
              </span>
            </div>
            <div class="product-card-details">
              <span class="detail-item">Qty: {{ item.Quantity }}</span>
              <span class="detail-separator">|</span>
              <span class="detail-item">{{
                formatPrice(item.Price ?? 0)
              }}</span>
            </div>
          </div>
        }

        <!-- Totals Summary -->
        <div class="mobile-totals">
          <div class="totals-row">
            <span>Items Total:</span>
            <span>{{ getItemsTotalBeforeDiscount() }}</span>
          </div>
          @if (hasPriceDiscounts()) {
            <div class="totals-row discount">
              <span>Price Discount:</span>
              <span>{{ getPriceDiscount() }}</span>
            </div>
          }
          @for (coupon of getCouponDiscounts(); track coupon.Description) {
            <div class="totals-row discount">
              <span>
                <i class="pi pi-ticket mr-1"></i>
                Coupon ({{ coupon.Description }}):
              </span>
              <span>{{ formatPrice(-Math.abs(coupon.Amount)) }}</span>
            </div>
          }
          <div class="totals-row subtotal">
            <span>Subtotal:</span>
            <span>{{ getTotalPrice() }}</span>
          </div>
          @if (hasShippingOrTax()) {
            <div class="totals-row order-total">
              <span class="order-total-label-mobile">
                Order total
                <p-button
                  icon="pi pi-dollar"
                  [rounded]="true"
                  [text]="true"
                  size="small"
                  (onClick)="onTotalsIconClick($event)"
                  pTooltip="View Order Total Summary"
                  tooltipPosition="top"
                  styleClass="totals-icon-btn-mobile"
                />:
              </span>
              <span>{{ getOrderTotal() }}</span>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
